export default __webpack_public_path__ + "static/media/delete.1129c53a.svg";